export default {"src":"/_next/static/media/youtube-icon.4afd4780.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};